export default "__VITE_ASSET__BmkPaIYW__"